import {
    createContext,
    useContext,
    useEffect
} from "react";
import type {
    FieldGroupContextType,
    FieldSetContextType,
    FieldContextType
} from "./type";
import {
    warnOnce
} from "../../utils/development";

export const FieldContext = createContext<FieldContextType | undefined>(undefined);

export const FieldSetContext = createContext<FieldSetContextType | undefined>(undefined);

export const FieldGroupContext = createContext<FieldGroupContextType | undefined>(undefined);

export const useFieldContext = (): FieldContextType | undefined => {
    return useContext(FieldContext);
};

export const useFieldSetContext = (): FieldSetContextType | undefined => {
    return useContext(FieldSetContext);
};

export const useFieldGroupContext = (): FieldGroupContextType | undefined => {
    return useContext(FieldGroupContext);
};

export const useFieldOutsideWarning = ({
    isInside,
    parent,
    part
}: {
    isInside: boolean;
    parent: string;
    part: string;
}) => {
    useEffect(() => {
        if(isInside) {
            return;
        }

        warnOnce({
            message: `Field.${part}: must be rendered inside <${parent}>.`
        });
    }, [
        isInside,
        parent,
        part
    ]);
};
